import 'jquery';

const scriptURL = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';

if (window.ShopifyBuy && window.ShopifyBuy.UI) {
	ShopifyBuyInit();
} else {
	loadScript();
}

function loadScript() {
	var script = document.createElement('script');
	script.async = true;
	script.src = scriptURL;
	(document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0]).appendChild(script);
	script.onload = ShopifyBuyInit;
}

function ShopifyBuyInit() {
	var client = ShopifyBuy.buildClient({
		domain: 'ama-the-giraffe.myshopify.com',
		storefrontAccessToken: '5c64ca960522d073bcec320133955785',
	});
	ShopifyBuy.UI.onReady(client).then(onShopifyReady);
}

function onShopifyReady(ui) {
	jQuery('.js-buy').each(function () {
		const $this = jQuery(this);
		const options = jQuery.extend({}, $this.data());

		ui.createComponent('product', {
			id: '7038142742685',
			node: this,
			moneyFormat: '%E2%82%AC%7B%7Bamount_with_comma_separator%7D%7D',
			options: {
				"product": {
					"styles": {
						"product": {
							"@media (min-width: 601px)": {
								"max-width": "calc(25% - 20px)",
								"margin-left": "20px",
								"margin-bottom": "50px"
							}
						},
						"button": {
							"font-weight": "bold",
							"color": "#334d8a",
							":hover": {
								"color": "#334d8a",
								"background-color": "#9cc8e0"
							},
							"background-color": "#addef9",
							":focus": {
								"background-color": "#9cc8e0"
							},
							"border-radius": "27px",
							"padding-left": "18px",
							"padding-right": "18px"
						}
					},
					"contents": {
						"img": false,
						"title": false,
						"price": false
					},
					"text": {
						"button": "Add to cart"
					}
				},
				"productSet": {
					"styles": {
						"products": {
							"@media (min-width: 601px)": {
								"margin-left": "-20px"
							}
						}
					}
				},
				"modalProduct": {
					"contents": {
						"img": false,
						"imgWithCarousel": true,
						"button": false,
						"buttonWithQuantity": true
					},
					"styles": {
						"product": {
							"@media (min-width: 601px)": {
								"max-width": "100%",
								"margin-left": "0px",
								"margin-bottom": "0px"
							}
						},
						"button": {
							"font-weight": "bold",
							"color": "#334d8a",
							":hover": {
								"color": "#334d8a",
								"background-color": "#9cc8e0"
							},
							"background-color": "#addef9",
							":focus": {
								"background-color": "#9cc8e0"
							},
							"width": "100%",
							"height": "100%",
							"border-radius": "27px",
							"padding-left": "18px",
							"padding-right": "18px"
						}
					},
					"text": {
						"button": "Add to cart"
					}
				},
				"option": {},
				"cart": {
					"styles": {
						"button": {
							"font-weight": "bold",
							"color": "#334d8a",
							":hover": {
								"color": "#334d8a",
								"background-color": "#9cc8e0"
							},
							"background-color": "#addef9",
							":focus": {
								"background-color": "#9cc8e0"
							},
							"border-radius": "27px"
						}
					},
					"text": {
						"total": "Subtotal",
						"button": "Checkout"
					}
				},
				"toggle": {
					"styles": {
						"toggle": {
							"font-weight": "bold",
							"background-color": "#addef9",
							":hover": {
								"background-color": "#9cc8e0"
							},
							":focus": {
								"background-color": "#9cc8e0"
							}
						},
						"count": {
							"color": "#334d8a",
							":hover": {
								"color": "#334d8a"
							}
						},
						"iconPath": {
							"fill": "#334d8a"
						}
					}
				}
			},
		});
	});
}
